import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import styles from './SearchGrid.module.css';
import { useTranslation } from 'react-i18next';

const { Grid } = MaterialUiCore;

let SearchGrid = ({ searchMatches, setSearchResultsClick, showChildOfBucketLeftPanel }) => {
    const [searchOut, setSearchOut] = React.useState([]);
    const { t } = useTranslation('commonLang');

    React.useEffect(() => {
        let finalOut = [];
        let groupArr = [];
        Object.keys(searchMatches)
            .sort((a, b) => {
                if (searchMatches[a].name < searchMatches[b].name) {
                    return -1;
                }
                if (searchMatches[a].name > searchMatches[b].name) {
                    return 1;
                }
            })
            .map((bucket) => {
                let obj = {};
                obj[searchMatches[bucket].name] = {};
                obj[searchMatches[bucket].name]['name'] = searchMatches[bucket].name;
                obj[searchMatches[bucket].name]['searchGridPages'] = [];
                obj[searchMatches[bucket].name]['navKey'] = bucket;
                //obj[searchMatches[bucket].name]["pages"]=searchMatches[bucket].pages;
                groupArr = [];

                if (
                    !Object.prototype.hasOwnProperty.call(searchMatches[bucket], 'searchPages') ||
                    Object.keys(searchMatches[bucket]['searchPages']).length == 0
                )
                    obj[searchMatches[bucket].name]['pages'] = searchMatches[bucket].pages;

                Object.keys(searchMatches[bucket]['searchPages'])
                    .sort((p, q) => {
                        if (
                            searchMatches[bucket]['searchPages'][p].name < searchMatches[bucket]['searchPages'][q].name
                        ) {
                            return -1;
                        }
                        if (
                            searchMatches[bucket]['searchPages'][p].name > searchMatches[bucket]['searchPages'][q].name
                        ) {
                            return 1;
                        }
                    })
                    .map((pg) => {
                        if (
                            !Object.prototype.hasOwnProperty.call(
                                searchMatches[bucket]['searchPages'][pg],
                                'searchPages',
                            )
                        ) {
                            let tempObj = {};

                            tempObj = {
                                crumb: [searchMatches[bucket]],
                                name: searchMatches[bucket]['searchPages'][pg].name,
                                route: searchMatches[bucket]['searchPages'][pg].route,
                                navKey: pg,
                            };

                            groupArr.push(tempObj);
                        } else {
                            if (groupArr.length > 0)
                                obj[searchMatches[bucket].name]['searchGridPages'].push({
                                    results: groupArr,
                                    crumb: groupArr[0]['crumb'],
                                });
                            groupArr = [];
                            let tempObj = {};
                            tempObj = {
                                crumb: [searchMatches[bucket], searchMatches[bucket]['searchPages'][pg]],
                                name: searchMatches[bucket]['searchPages'][pg].name,
                                route: searchMatches[bucket]['searchPages'][pg].route,
                                searchPages: searchMatches[bucket]['searchPages'][pg]['searchPages'],
                                navKey: pg,
                            };
                            obj[searchMatches[bucket].name]['searchGridPages'].push({
                                results: tempObj,
                                crumb: tempObj['crumb'],
                            });
                        }
                    });
                if (groupArr.length != 0)
                    obj[searchMatches[bucket].name]['searchGridPages'].push({
                        results: groupArr,
                        crumb: groupArr[0]['crumb'],
                    });

                finalOut.push(obj[searchMatches[bucket].name]);
            });

        setSearchOut(finalOut);
    }, [searchMatches]);

    return (
        <Grid data-testid="search-grid">
            {searchOut &&
                Object.keys(searchOut).map((bucket) => {
                    if (!searchOut[bucket]['searchGridPages'] || searchOut[bucket]['searchGridPages'].length == 0) {
                        return (
                            <div className={styles['main']}>
                                <div
                                    data-testid="only-bucket"
                                    className={styles['search-item-bucket']}
                                    onClick={() => {
                                        setSearchResultsClick(true);
                                        showChildOfBucketLeftPanel(searchOut[bucket]);
                                    }}
                                >
                                    {t(searchOut[bucket].navKey) == searchOut[bucket].navKey
                                        ? searchOut[bucket].name
                                        : t(searchOut[bucket].navKey)}
                                </div>
                                <hr />
                            </div>
                        );
                    } else {
                        return Object.keys(searchOut[bucket]['searchGridPages']).map((pgArray, i) => {
                            if (searchOut[bucket]['searchGridPages'][pgArray]['crumb'].length == 1) {
                                return (
                                    <div className={styles['main']}>
                                        <div
                                            data-testid="bucket-one-crumb"
                                            className={styles['search-item-bucket']}
                                            onClick={() => {
                                                setSearchResultsClick(true);
                                                showChildOfBucketLeftPanel(
                                                    searchOut[bucket]['searchGridPages'][pgArray]['crumb'][0],
                                                );
                                            }}
                                        >
                                            {t(searchOut[bucket].navKey) == searchOut[bucket].navKey
                                                ? searchOut[bucket].name
                                                : t(searchOut[bucket].navKey)}
                                        </div>
                                        {searchOut[bucket]['searchGridPages'][pgArray]['results'].map((el, ind) => {
                                            //if i give data-test of search-module-page-crumb-one to the below grid,the grid renders as 3 components with same data-test
                                            return (
                                                <Grid
                                                    key={ind}
                                                    className={`${styles['nav-item']}`}
                                                    onClick={() => {
                                                        showChildOfBucketLeftPanel(el);
                                                    }}
                                                >
                                                    <span
                                                        data-testid="search-module-page-crumb-one"
                                                        className={styles['item-text']}
                                                    >
                                                        {t(el.navKey) == el.navKey ? el.name : t(el.navKey)}
                                                    </span>
                                                </Grid>
                                            );
                                        })}
                                        <hr />
                                    </div>
                                );
                            } else if (searchOut[bucket]['searchGridPages'][i]['crumb'].length == 2) {
                                return (
                                    <div className={styles['main']}>
                                        <div data-testid="bucket-two-crumbs" className={styles['search-item-bucket']}>
                                            <span
                                                data-testid="first-bucket-in-crumb"
                                                onClick={() => {
                                                    setSearchResultsClick(true);
                                                    showChildOfBucketLeftPanel(
                                                        searchOut[bucket]['searchGridPages'][pgArray]['crumb'][0],
                                                    );
                                                }}
                                            >
                                                {t(searchOut[bucket]['searchGridPages'][pgArray]['crumb'][0].navKey) ==
                                                searchOut[bucket]['searchGridPages'][pgArray]['crumb'][0].navKey
                                                    ? searchOut[bucket]['searchGridPages'][pgArray]['crumb'][0].name
                                                    : t(
                                                          searchOut[bucket]['searchGridPages'][pgArray]['crumb'][0]
                                                              .navKey,
                                                      )}
                                            </span>
                                            <i
                                                className="sct-icon icon-Arrow-Right-18 "
                                                style={{ fontSize: '16px', marginLeft: '8px', marginRight: '8px' }}
                                            ></i>
                                            <span
                                                data-testid="second-bucket-in-crumb"
                                                onClick={() => {
                                                    setSearchResultsClick(true);
                                                    showChildOfBucketLeftPanel(
                                                        searchOut[bucket]['searchGridPages'][i]['crumb'][1],
                                                    );
                                                }}
                                            >
                                                {t(searchOut[bucket]['searchGridPages'][i]['crumb'][1].navKey) ==
                                                searchOut[bucket]['searchGridPages'][i]['crumb'][1].navKey
                                                    ? searchOut[bucket]['searchGridPages'][i]['crumb'][1].name
                                                    : t(searchOut[bucket]['searchGridPages'][i]['crumb'][1].navKey)}
                                            </span>
                                        </div>
                                        {searchOut[bucket]['searchGridPages'][pgArray]['results']['searchPages'] &&
                                            Object.keys(
                                                searchOut[bucket]['searchGridPages'][pgArray]['results']['searchPages'],
                                            ).map((pg, ind) => {
                                                return (
                                                    <Grid key={ind} className={`${styles['nav-item']}`}>
                                                        <span
                                                            data-testid="search-module-page-crumb-two"
                                                            onClick={() => {
                                                                showChildOfBucketLeftPanel(
                                                                    searchOut[bucket]['searchGridPages'][pgArray][
                                                                        'results'
                                                                    ]['searchPages'][pg],
                                                                );
                                                            }}
                                                            className={styles['item-text']}
                                                        >
                                                            {t(
                                                                searchOut[bucket]['searchGridPages'][pgArray][
                                                                    'results'
                                                                ]['searchPages'][pg].navKey,
                                                            ) ==
                                                            searchOut[bucket]['searchGridPages'][pgArray]['results'][
                                                                'searchPages'
                                                            ][pg].navKey
                                                                ? searchOut[bucket]['searchGridPages'][pgArray][
                                                                      'results'
                                                                  ]['searchPages'][pg].name
                                                                : t(
                                                                      searchOut[bucket]['searchGridPages'][pgArray][
                                                                          'results'
                                                                      ]['searchPages'][pg].navKey,
                                                                  )}
                                                        </span>
                                                    </Grid>
                                                );
                                            })}
                                        <hr />
                                    </div>
                                );
                            }
                        });
                    }
                })}
        </Grid>
    );
};

export default SearchGrid;
